import { type GoogleMarker } from "~/domains/salesPartner/types/SalesPartnerTypes";
import { COOKIE_NAMES, deletePreferredPartnerCookie } from "~/domains/affiliate/utils/utils";
import { getCookie } from "~/common/utils/cookie";

export const hasActiveSelectedSubsidiary = (
  list: GoogleMarker[],
  selectedSubsidiaryId: string | undefined,
): boolean => {
  if (!selectedSubsidiaryId) {
    return false;
  }

  // find at least one subsidiary
  return list.some((marker) => marker.subsidiaryId === selectedSubsidiaryId);
};

export const makersWithPreferredSalesPartner = (
  list: GoogleMarker[],
  affiliateId: string,
  selectedSubsidiaryId: string | undefined,
): GoogleMarker[] => {
  // check if requires to activate the filtering system
  if (!affiliateId || list.length === 0 || !hasActiveSelectedSubsidiary(list, selectedSubsidiaryId)) {
    return list;
  }

  // grab the default selected Subsidiary
  const id = selectedSubsidiaryId ?? "";

  // filter an return
  return list
    .filter((marker) => marker.subsidiaryId === id)
    .concat(list.filter((marker) => marker.subsidiaryId !== id));
};

export const clearSavedSalesPartnerCookieOnAccountUncheck = (savedPartner: SalesPartnerDTO | undefined) => {
  const cookie = getCookie(COOKIE_NAMES.PARTNER)?.value;
  if (savedPartner && savedPartner.affiliateId === cookie) {
    deletePreferredPartnerCookie();
  }
};
